export const CHANGE_MOBILE_TAB = 'ui/CHANGE_MOBILE_TAB';
export const TOGGLE_CHAT = 'ui/TOGGLE_CHAT';
export const TOGGLE_DOCTOR_MESSAGES = 'ui/TOGGLE_DOCTOR_MESSAGES';
export const TOGGLE_INTAKE_FORM = 'ui/TOGGLE_INTAKE_FORM';
export const TOGGLE_PATIENT_PROFILE = 'ui/TOGGLE_PATIENT_PROFILE';
export const TOGGLE_ENCOUNTER_INFO = 'ui/TOGGLE_ENCOUNTER_INFO';
export const GET_COUNTERS = 'ui/GET_COUNTERS';
export const SCROLL_ROOT = 'ui/SCROLL_ROOT';
export const GET_CONNECT_GOOGLE_LINK = 'ui/GET_CONNECT_GOOGLE_LINK';

export function getConnectGoogleLink() {
    return {
        type: GET_CONNECT_GOOGLE_LINK,
        httpRequest: {
            method: 'get',
            path: 'users/google/oauth',
        },
    };
}

export function scrollRoot(x) {
    return {
        type: SCROLL_ROOT,
        x,
    };
}

export function getCounters() {
    return {
        type: GET_COUNTERS,
        httpRequest: {
            method: 'get',
            path: '/users/counters',
        },
    };
}

export function changeMobileTab(tab) {
    return {
        type: CHANGE_MOBILE_TAB,
        activeTab: tab,
    };
}

export function toggleChat() {
    return {
        type: TOGGLE_CHAT,
    };
}

export function toggleIntakeForm() {
    return {
        type: TOGGLE_INTAKE_FORM,
    };
}

export function togglePatientProfile() {
    return {
        type: TOGGLE_PATIENT_PROFILE,
    };
}

export function toggleEncounterInfo() {
    return {
        type: TOGGLE_ENCOUNTER_INFO,
    };
}

export function toggleDoctorMessages() {
    return {
        type: TOGGLE_DOCTOR_MESSAGES,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/ui/uiActions.js